import React from 'react';
import { CheckCircle, Award, Users, Expand, Eye } from 'lucide-react';
import { whyYBro } from '@/data/mock';

const iconMap = [
  CheckCircle,
  Award,
  Users,
  Expand,
  Eye,
];

export const WhyYBro = () => {
  return (
    <section className="py-24 lg:py-32 bg-ybro-light/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-ybro-primary font-semibold text-sm uppercase tracking-wider mb-4 block font-body">Why Choose Us</span>
          <h2 className="text-3xl lg:text-4xl font-bold font-heading text-slate-900 mb-6">
            {whyYBro.title}
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed font-body">
            {whyYBro.intro}
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyYBro.reasons.map((reason, index) => {
            const IconComponent = iconMap[index];
            return (
              <div 
                key={index}
                className="group relative p-8 rounded-2xl bg-white border border-slate-200 hover:border-ybro-primary/40 hover:shadow-lg hover:shadow-ybro-primary/5 transition-all duration-500"
              >
                {/* Number badge */}
                <div className="absolute top-8 right-8 w-8 h-8 rounded-full bg-ybro-light group-hover:bg-ybro-primary/20 flex items-center justify-center transition-colors duration-300">
                  <span className="text-sm font-bold font-heading text-ybro-dark group-hover:text-ybro-primary transition-colors duration-300">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <div className="w-12 h-12 rounded-xl bg-ybro-light group-hover:bg-ybro-primary/20 flex items-center justify-center mb-6 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-6 h-6 text-ybro-primary" />}
                </div>

                <h3 className="text-xl font-bold font-heading text-slate-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-slate-500 leading-relaxed font-body">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
